export default function SemRegistros() {
  return (
    <p className="m-0 rounded-2xl bg-surface-0 px-6 py-8 text-center font-display text-lg font-bold text-content shadow-jj-01" tabIndex={0}>
      Não há registros para esse ciclo.
    </p>
  );
}
